// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"ab90ffc5","138":"7ac7655e","193":"b2138afb","238":"91884fa0","540":"ca79d021","648":"b2138afb","681":"ab90ffc5","798":"cad9dcd0"}[chunkId] + ".chunk.css";
};